import { getNowMinTimezoneTime } from 'chameleon-src/components/assign/AssignManageForm/utils';

const handleFormUpdate = ({
  prevProps,
  props,
  selectedSectionsMinTimezone,
  storedFormValues,
}) => {
  const {
    isFinalExam,
    formData,
    initialize,
    assessmentGroupInfo,
    hasScrambleQuestionsPerStudent = false,
  } = props;
  const { formData: prevFormData } = prevProps;
  const {
    assignmentId,
    startsAt,
    dueAt,
    timer,
    printToggle,
    hasScrambledOrder,
    hasImmediateFeedback,
    immediateFeedbackAttempts,
    allowLateSubmission,
    isSoftTimer,
  } = formData;
  const {
    printToggle: prevPrintToggle,
    startsAt: prevStartsAt,
    dueAt: prevDueAt,
  } = prevFormData || {};
  const nowMinTimezoneTime = getNowMinTimezoneTime(
    isFinalExam,
    selectedSectionsMinTimezone,
    assessmentGroupInfo,
  );
  let correctStartsAt = startsAt;
  let correctDueAt = dueAt;
  let correctTimer = timer;
  let correctAllowLateSubmission = allowLateSubmission;
  let correctIsSoftTimer = isSoftTimer;
  let correctHasImmediateFeedback = hasImmediateFeedback;
  let correctImmediateFeedbackAttempts = hasImmediateFeedback
    ? immediateFeedbackAttempts
    : '0';
  //hasScrambleQuestionsPerStudent is provided by update settings modal usage
  let updatedHasScrambledOrder =
    hasScrambledOrder || hasScrambleQuestionsPerStudent;
  let hasForcedScrambledOrder = false;
  if (!prevPrintToggle && printToggle) {
    // when scramble is set to `scramble_questions_per_student`, and format is changed to `print`,
    // we have to update the value to `No`
    if (updatedHasScrambledOrder === 'scramble_questions_per_student') {
      updatedHasScrambledOrder = false;
      hasForcedScrambledOrder = true;
    }
    correctStartsAt = null;
    correctDueAt = null;
    correctTimer = null;
    correctAllowLateSubmission = false;
    correctHasImmediateFeedback = false;
    correctImmediateFeedbackAttempts = '0';
    correctIsSoftTimer = false;
  } else if (prevPrintToggle && !printToggle) {
    const {
      startsAt: storedStartsAt,
      dueAt: storedDueAt,
      timer: storedTimer,
      allowLateSubmission: storedAllowLateSubmission,
      isSoftTimer: storedIsSoftTimer,
    } = storedFormValues;

    if (
      !storedStartsAt ||
      (storedStartsAt && storedStartsAt.isAfter(nowMinTimezoneTime))
    ) {
      correctStartsAt = storedStartsAt;
    } else {
      correctStartsAt = nowMinTimezoneTime;
    }

    correctDueAt = storedDueAt;
    correctTimer = storedTimer;
    correctAllowLateSubmission = storedAllowLateSubmission;
    hasForcedScrambledOrder = false;
    correctIsSoftTimer = storedIsSoftTimer;
  }

  let updatedStartsAt = startsAt;
  let updatedDueAt = dueAt;
  const isNewStartAt =
    (prevStartsAt &&
      startsAt &&
      prevStartsAt.valueOf() !== startsAt.valueOf()) ||
    prevStartsAt !== startsAt;
  const isNewDueAt =
    (prevDueAt && dueAt && prevDueAt.valueOf() !== dueAt.valueOf()) ||
    prevDueAt !== dueAt;
  if ((isNewStartAt || isNewDueAt) && !isFinalExam) {
    if (startsAt) {
      updatedStartsAt = startsAt.clone().utcOffset(0, true);
    }

    if (dueAt) {
      updatedDueAt = dueAt.clone().utcOffset(0, true);
    }
  }

  if (
    correctStartsAt !== updatedStartsAt ||
    correctDueAt !== updatedDueAt ||
    correctTimer !== timer ||
    correctImmediateFeedbackAttempts !== immediateFeedbackAttempts ||
    correctHasImmediateFeedback !== hasImmediateFeedback ||
    correctAllowLateSubmission !== allowLateSubmission ||
    correctIsSoftTimer !== isSoftTimer
  ) {
    const {
      assignees,
      updateAssignees,
      allAssignees,
      scoreDisplay,
      isAssessmentRenamed,
      title,
      studentScoring,
      isSecure,
      duration,
      attestationAgreementChecked,
      finalExamSessions,
      students,
      testTakingLocationDisplay,
    } = formData;

    initialize({
      assignmentId,
      startsAt: correctStartsAt,
      dueAt: correctDueAt,
      timer: correctTimer,
      isSoftTimer: correctTimer && correctIsSoftTimer,
      allowLateSubmission: correctAllowLateSubmission,
      assignees,
      updateAssignees,
      allAssignees,
      printToggle,
      scoreDisplay,
      isAssessmentRenamed,
      title,
      hasScrambledOrder: updatedHasScrambledOrder,
      hasForcedScrambledOrder,
      hasImmediateFeedback: correctHasImmediateFeedback,
      immediateFeedbackAttempts: correctImmediateFeedbackAttempts,
      studentScoring,
      isSecure,
      duration: isFinalExam ? finalExamSessions.duration : duration,
      attestationAgreementChecked,
      finalExamSessions,
      students,
      testTakingLocation: testTakingLocationDisplay,
    });
  }
};

export default handleFormUpdate;
